/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Signup_Toast_Verify_Email_TitleInputs */

const en_auth_signup_toast_verify_email_title = /** @type {(inputs: Auth_Signup_Toast_Verify_Email_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check your email`)
};

const pl_auth_signup_toast_verify_email_title = /** @type {(inputs: Auth_Signup_Toast_Verify_Email_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sprawdź swoją skrzynkę`)
};

/**
* | output |
* | --- |
* | "Check your email" |
*
* @param {Auth_Signup_Toast_Verify_Email_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const auth_signup_toast_verify_email_title = /** @type {((inputs?: Auth_Signup_Toast_Verify_Email_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Signup_Toast_Verify_Email_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_auth_signup_toast_verify_email_title(inputs)
	return en_auth_signup_toast_verify_email_title(inputs)
});